import React, { Component } from 'react';
import { SimpleSelect } from 'react-selectize-advizr';
import debounce from 'lodash/debounce';
import { scroller } from '../../js/app/react/helpers.objects';
import AdvForm from '../CommonComponents/AdvForm';
import MissingInfo from '../ErrorPages/MissingInfoView';
import PlanNotStarted from '../CommonComponents/PlanNotStarted';
import TableVerticalSide from '../ProjectedTableVerticalSide/TableVerticalSideView';
import { getTableSideProps } from './Helpers/BalanceSheetHelpers';
import { PDFTitle } from '../PDFRenderer/components/PDFTitle/PDFTitle';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { RawButton } from '../CommonComponents/OPL/Button/Button.styles';
import { Icon } from '../CommonComponents/OPL/Icon/Icon';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { ProjectedCashFlowReportPrint } from '../ProjectedCashFlowReportPrint/ProjectedCashFlowReport.print';

class ProjectedCashFlowReportView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded_rows: [],
      stopLeftScroll: true,
      stopRightScroll: false,
    };
  }

  UNSAFE_componentWillMount() {
    const { Mode, fpId, isPrint } = this.props;
    this.fetch(Mode, fpId, isPrint);
  }

  componentDidMount() {
    const { portalName } = this.props;

    document.title = `Reports - Cash Flow | ${portalName}`;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { Mode, fpId, isPrint } = nextProps;
    if (nextProps.fpId !== this.props.fpId) {
      this.fetch(Mode, fpId, isPrint);
    }
  }

  setExpanded(group_name, self) {
    const { expanded_rows } = self.state;
    const local_rows = expanded_rows.slice();
    const row_index = expanded_rows.indexOf(`${group_name}`);

    if (row_index > -1) {
      local_rows.splice(row_index, 1);
    } else {
      local_rows.push(`${group_name}`);
    }

    this.setState({
      expanded_rows: local_rows,
    });
  }

  fetch(mode, fpId, isPrint, expandCurrentYear) {
    const { clientId, fetch_data } = this.props;
    const local_mode = typeof mode === 'undefined' ? this.props.mode : mode;

    fetch_data(local_mode, clientId, fpId, isPrint, expandCurrentYear);
  }

  renderTableHead() {
    const { People, Periods, PrincipalAges, SpouseAges, isPrint, Mode, fpId } = this.props;
    const has_spouse = People.length > 1;
    const localPeriods = isPrint ? Periods.slice(0, 5) : Periods;
    const local_principalAges = isPrint ? PrincipalAges.slice(0, 5) : PrincipalAges;
    const local_spouseAges =
      People.length > 1 ? (isPrint ? SpouseAges.slice(0, 5) : SpouseAges) : null;
    return (
      <li className="thead">
        <ul className={`${has_spouse ? ' has-spouse' : ''}`}>
          {localPeriods.map((curr, idx) => {
            return (
              <li key={`year_${curr.Text}`} id={`year_${curr.Text}`}>
                <span className="blue">
                  <Box display="flex" alignItems="center" justifyContent="flex-end">
                    {curr.IsToggleable && !isPrint && (
                      <RawButton
                        css="margin-right: 4px; display: inline-block; line-height: 0"
                        onClick={() => {
                          const expandCurrentYear = !curr.IsMonth;

                          this.fetch(Mode, fpId, isPrint, expandCurrentYear);
                        }}
                        aria-label="View Current Year"
                      >
                        <Icon
                          className={curr.IsMonth ? 'far fa-minus-circle' : 'far fa-plus-circle'}
                        />
                      </RawButton>
                    )}
                    {curr.Text}
                  </Box>
                </span>
                <span>{local_principalAges[idx]}</span>
                {has_spouse && <span>{local_spouseAges[idx]}</span>}
              </li>
            );
          })}
        </ul>
      </li>
    );
  }

  renderTableRow(opts = {}) {
    const o = Object.assign(
      {
        parent_name: '',
        headline: '',
        cells: [],
        force_odd: false,
        is_detail: false,
        on_click: undefined,
        extra_row_classes: '',
      },
      opts,
    );
    const totals = o.cells.map((val, i) => (
      <li key={i} className={val < 0 ? 'red' : ''}>
        ${ADV.util.number_format(Math.abs(val))}
      </li>
    ));
    const { isPrint } = this.props;

    const rowClasses = [];
    if (o.force_odd) {
      rowClasses.push('odd');
    }
    if (o.is_detail) {
      rowClasses.push('detail');
    }
    if (o.extra_row_classes) {
      rowClasses.push(...o.extra_row_classes.split(' '));
    }
    return <ul className={rowClasses.join(' ')}>{isPrint ? totals.slice(0, 5) : totals}</ul>;
  }

  setScrollAvailability() {
    const setAvailability = () => {
      const scrollOffset = this.scrollContainer.scrollLeft;
      this.setState({
        stopLeftScroll: scrollOffset <= 0,
        stopRightScroll:
          scrollOffset >= this.scrollContainer.scrollWidth - this.scrollContainer.offsetWidth,
      });
    };
    debounce(setAvailability, 150)();
  }

  renderTableSection(headline, rows, classNames) {
    const has_subs = rows[0].Totals;
    const { isPrint } = this.props;
    const local_rows = has_subs
      ? rows[0].Totals.map((_, i) => <li key={i}>{'\u00a0'}</li>)
      : rows.map((r, i) => (
          <li key={i} className={r < 0 ? 'red' : ''}>
            ${ADV.util.number_format(Math.abs(r))}
          </li>
        ));
    const headlineComponent = (
      <ul className={`subheader odd${classNames ? ` ${classNames}` : ''}`}>
        {isPrint ? local_rows.slice(0, 5) : local_rows}
      </ul>
    );
    const agg_rows = has_subs
      ? rows.map((r, key) => {
          const has_subcategories = r.SubCategories && r.SubCategories.length;
          const is_odd = key % 2 === 1;
          const table_row = this.renderTableRow({
            parent_name: headline,
            headline: r.Name,
            cells: r.Totals,
            force_odd: is_odd,
            is_detail: false,
            on_click: has_subcategories
              ? () => {
                  this.setExpanded(`${headline}|${r.Name}`, this);
                }
              : undefined,
          });
          const sub_rows = [];

          if (has_subcategories) {
            r.SubCategories.forEach(sub_cat => {
              if (this.state.expanded_rows.includes(`${headline}|${r.Name}`)) {
                sub_rows.push(
                  this.renderTableRow({
                    headline: sub_cat.Key,
                    cells: sub_cat.Value,
                    force_odd: is_odd,
                    is_detail: true,
                  }),
                );
              }
            });
          }
          return [table_row, sub_rows];
        })
      : [];
    const flattened = agg_rows.reduce((a, b) => a.concat(b), []);

    return [headlineComponent, flattened];
  }

  scroll_to_year(opt) {
    this.scrollContainer.scrollLeft = 0;
    const val = opt.value;
    const year_target = document.getElementById(`year_${val}`);
    this.scrollContainer.scrollLeft =
      ADV.util.getPosition(year_target).left - ADV.util.getPosition(this.scrollContainer).left;
  }

  renderHeader() {
    const { Milestones, title, isPrint } = this.props;

    if (isPrint) {
      return <PDFTitle title={title} />;
    }

    return (
      <header>
        <Text as="h1" fontSize="h3" fontWeight={600} mb="16">
          Cash Flow
        </Text>
        <AdvForm className="milestone-selector-container hide-on-mobile-screens">
          <SimpleSelect
            className="md"
            placeholder="Jump to Milestone"
            options={Milestones.map(m => ({ label: m.Name, value: m.Year }))}
            onValueChange={this.scroll_to_year.bind(this)}
            inputProps={{
              'aria-label': 'adv-jump-to-milestone',
            }}
          />
        </AdvForm>
      </header>
    );
  }

  render() {
    const {
      Inflows,
      Outflows,
      InflowsTotals,
      OutflowsTotals,
      NetCashflow,
      is_initialized,
      isPrint,
      People,
      errors,
      error_type,
      clientId,
    } = this.props;
    const { stopRightScroll, stopLeftScroll } = this.state;

    const setExpanded = (owner, groupName) => () => this.setExpanded(`${owner}|${groupName}`, this);

    switch (error_type) {
      case 'PlanNotStarted':
        return <PlanNotStarted clientId={clientId} />;
      case 'MissingInfo':
        return <MissingInfo clientId={clientId} errors={errors} />;
    }

    if (is_initialized) {
      if (!isPrint) {
        return (
          <Box
            id="ProjectedCashFlowReport"
            className={`
                        ${isPrint ? 'is-print' : ''}
                        ${People.length > 1 ? 'has-spouse' : ''}
                    `}
          >
            {this.renderHeader()}
            <section className={`widgetize${isPrint ? ' is-print' : ''}`}>
              {!isPrint && (
                <button
                  onClick={() => scroller.call(this, 'left')}
                  aria-label="Scroll Left"
                  className={`scroll left${
                    stopLeftScroll || this.state.isScrolling ? ' disabled' : ''
                  }`}
                />
              )}
              {!isPrint && (
                <button
                  onClick={() => scroller.call(this, 'right')}
                  aria-label="Scroll Right"
                  className={`scroll right${
                    stopRightScroll || this.state.isScrolling ? ' disabled' : ''
                  }`}
                />
              )}
              <section
                className="owner-table"
                onScroll={() => this.setScrollAvailability()}
                ref={c => (this.scrollContainer = c)}
              >
                <TableVerticalSide
                  {...getTableSideProps(this.state, this.props, { setExpanded })}
                />
                <div className="table-wrap">
                  <ul className="table">
                    {this.renderTableHead()}
                    <li className="tbody">
                      {this.renderTableSection('Inflow', Inflows)}
                      {this.renderTableRow({
                        headline: 'Total Inflow',
                        cells: InflowsTotals,
                        force_odd: true,
                        extra_row_classes: 'light-border-top light-border-bottom bold green',
                      })}
                      {this.renderTableSection('Outflow', Outflows)}
                      {this.renderTableRow({
                        headline: 'Total Outflow',
                        cells: OutflowsTotals,
                        force_odd: true,
                        extra_row_classes: 'light-border-top bold red',
                      })}
                      {this.renderTableSection('Net Cash Flow', NetCashflow, 'last bold')}
                    </li>
                  </ul>
                </div>
              </section>
            </section>
          </Box>
        );
      }
      return <ProjectedCashFlowReportPrint {...this.props} />;
    }

    return null;
  }
}

export default ProjectedCashFlowReportView;
